<template>
	<div class="integration-details">
		<div class="header">
			<DetailsHeader
				:logoUrl="integrationObject?.icon_url"
				:title="integrationObject?.name"
			>
			</DetailsHeader>
		</div>

		<div class="content" v-if="!connection?.configuration_url || connecting">
			<img class="logo" :src="integrationObject?.image_url" />
			<div class="desc">
				Create personalized learning at scale and help learners realize their
				true potential.
			</div>
			<Button primary :loading="connecting" @click="connect">
				<RightLeftIcon type="regular" />
				<span v-t="'admin_integrations_connect_button'" />
			</Button>
		</div>

		<div class="content" v-show="connection?.configuration_url && !connecting">
			<iframe :src="connection.configuration_url" @load="connecting = false" />
		</div>
	</div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { Button, useAlert } from '@/components/common'
import { RightLeftIcon } from '@/icons'
import { post } from '../common'
import DetailsHeader from './DetailsHeader'

// Props
const props = defineProps({
	integrationId: {
		type: [String, Number],
		required: true,
	},
	integrationObject: {
		type: Object,
		required: false,
	},
})

// Reactive Variables
const connecting = ref(false)
const connection = ref({})

// Utilities
const { t } = useI18n()
const alert = useAlert()

// Methods
async function connect() {
	connecting.value = true
	try {
		connection.value = await post(
			`/organization/integrations/${props.integrationId}/connections`
		)
	} catch (e) {
		console.error(e)
		alert.error(t('common_api_error_save'))
	}
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.integration-details {
	.content {
		height: calc(100vh - 125px);
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		iframe {
			height: 90%;
			width: 90%;
		}
	}

	.logo {
		min-width: 275px;
		min-height: 125px;
		border-radius: 12px;
	}

	.desc {
		color: var(--neutral-500);
		font-size: 16px;
		max-width: 340px;
		text-align: center;
		margin: 24px 0;
		line-height: 25px;
	}
}
</style>
